@use '../../scss/global' as *;

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  .fluid-form-element {

  }
}
